<div
  class="screen-reader-only"
  #metaInfo
  tabindex="0"
  [attr.arial-label]="'meta_info_text' | translate"
>
  {{ 'meta_info_text' | translate }}
</div>
